import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "my-7 justify-self-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, { fluid: _ctx.isPublic }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view, null, {
                default: _withCtx(({ Component }) => [
                  (_openBlock(), _createBlock(_Suspense, { timeout: "0" }, {
                    fallback: _withCtx(() => [
                      _hoisted_1
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                          key: _ctx.$route.path
                        }))
                      ])
                    ]),
                    _: 2
                  }, 1024))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["fluid"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}